import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";

interface PublicAgentLayoutProps {
  children: React.ReactNode;
  isEmbedded?: boolean;
  brandColor: string;
  hideNavBar?: boolean;
}

export const PublicAgentLayout: React.FC<PublicAgentLayoutProps> = ({ 
  children, 
  isEmbedded = false,
  brandColor = "#060520",
  hideNavBar = false
}) => {
  const isMobile = useIsMobile();
  
  const customStyles = {
    "--primary": brandColor,
    "--primary-foreground": (brandColor === "#ffffff" || brandColor === "#fff") 
      ? "#000000" 
      : "#ffffff"
  } as React.CSSProperties;

  // For embedded view, just render without the background and no padding/margins
  if (isEmbedded) {
    return (
      <div 
        style={customStyles}
        className="w-full h-full flex flex-col bg-white overflow-hidden"
      >
        {children}
      </div>
    );
  }

  // For mobile view, use the full viewport height
  if (isMobile) {
    return (
      <div 
        style={{
          ...customStyles,
          backgroundColor: `${brandColor}17`,
          height: '100vh',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
        className="overflow-hidden"
      >
        <div className="bg-white flex-1 w-full h-full flex flex-col overflow-hidden">
          {children}
        </div>
      </div>
    );
  }

  // For desktop view, render with container style
  return (
    <div 
      style={{
        ...customStyles,
        backgroundColor: `${brandColor}17`
      }}
      className="min-h-screen h-screen flex flex-col"
    >
      <div 
        className="bg-white overflow-hidden w-full h-full flex flex-col shadow-lg rounded-lg"
      >
        {children}
      </div>
    </div>
  );
};
